// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import HomeImageLinks from './HomeImageLinks'

class PageHeader extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			imageLoaded: false
		}
	}

	componentWillReceiveProps( nextProps ) {
		if ( ! this.props.page || this.props.page == nextProps.page ) {
			return
		}

		const { page } = this.props

		if ( page.featured_image.url != nextProps.page.featured_image.url ) {
			this.setState({
				imageLoaded: false
			})
		}
	}

	handleImageLoaded = () => {
		this.setState({
			imageLoaded: true
		})
	}

	renderLoading() {
		return (
			<div className="hero hero-is-loading">
				<div className="-inner">
					<div className="-image"></div>
				</div>
			</div>
		)
	}

	renderContent() {
		const { page } = this.props
		const { imageLoaded } = this.state
		const wrapClass = imageLoaded ? '-image is-loaded' : '-image'
		const { params, path } = this.props.match

		if ( ! page ) {
			if ( '/' == path ) {
				return (
					<div className="hero">
						<div className="-inner">
							<div className="-image">

							</div>
						</div>
					</div>
				)
			} else {
				return (
					<div className="hero">
						<div className="-inner">

						</div>
					</div>
				)
			}
		}

		const wrapStyle = {
			paddingBottom: 100 / page.featured_image.aspect_ratio + '%'
		}

		var image
		let featuredImage = page.featured_image

		if ( page.featured_image_wide ) {
			featuredImage = page.featured_image_wide
		}

		const srcset = featuredImage.srcset ? featuredImage.srcset : undefined

		// Calculate CSS percentages:
		let imagePosition = null

		if ( featuredImage.focal_point ) {
			const percentageX = ( featuredImage.focal_point.x / featuredImage.width ) * 100
			const percentageY = ( featuredImage.focal_point.y / featuredImage.height ) * 100
			imagePosition = percentageX.toFixed( 0 ) + '% ' + percentageY.toFixed( 0 ) + '%'
		}

		const imageStyle = {
			objectPosition: imagePosition
		}

		if ( page.featured_image.url && page.featured_image_link ) {
			let imageLinkAttr = {}

			if ( page.featured_image_link.indexOf( 'http' ) > -1 ) {
				imageLinkAttr.target = '_blank'
				imageLinkAttr.rel = 'noopener'
			}

			image = (
				<div className={ wrapClass } style={ wrapStyle }>
					<a href={ page.featured_image_link } { ...imageLinkAttr }>
						<img
							className="-thumb"
							src={ featuredImage.thumb }
							alt={ featuredImage.alt }
							style={ imageStyle }
						/>

						<img
							className="-full"
							alt={ featuredImage.alt }
							src={ featuredImage.url }
							srcSet={ srcset }
							sizes="100vw"
							onLoad={ this.handleImageLoaded }
							style={ imageStyle }
						/>
					</a>
				</div>
			)
		} else if ( page.featured_image.url ) {
			image = (
				<div className={ wrapClass } style={ wrapStyle }>
					<img
						className="-thumb"
						src={ featuredImage.thumb }
						alt={ featuredImage.alt }
						style={ imageStyle }
					/>

					<img
						className="-full"
						alt={ featuredImage.alt }
						src={ featuredImage.url }
						srcSet={ srcset }
						sizes="100vw"
						onLoad={ this.handleImageLoaded }
						style={ imageStyle }
					/>
				</div>
			)
		} else {
			image = (
				<div className={ wrapClass }>
					<img
						className="-full"
						src={ siteData.site_featured_image_url }
						alt=""
						onLoad={ this.handleImageLoaded }
					/>
				</div>
			)
		}

		return (
			<div className="hero">
				<div className="-inner">
					{ image }

					{ '/' == this.props.location.pathname &&
						this.renderHomeContent()
					}
				</div>
			</div>
		)
	}

	renderHomeContent() {
		return (
			<div className="lower-image-links home-image-links on-not-mobile">
				<div className="wide-section">
					<HomeImageLinks />
				</div>
			</div>
		)
	}

	render() {
		return this.renderContent()
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( PageHeader )
